import React, { FC } from 'react';
import { ChatModel } from 'pages/Chat/Chat.Interfaces';
import { PubUserFormik } from './PubUserForm/PubUserFormik';
import { RegUserFormik } from './RegUserForm/RegUserFormik';

export const OfflineForm: FC<ChatModel> = props => {
	const { isPublic } = props;
	return isPublic ? <PubUserFormik {...props}></PubUserFormik> : <RegUserFormik {...props}></RegUserFormik>;
};
